import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

export default function GamificacaoMissoes() {
  const [showModal, setShowModal] = useState(false);
  const [showValidacaoModal, setShowValidacaoModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showHistoricoModal, setShowHistoricoModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAprovarModal, setShowAprovarModal] = useState(false);
  const [showReprovarModal, setShowReprovarModal] = useState(false);
  const [showSolicitarAjusteModal, setShowSolicitarAjusteModal] = useState(false);
  const [selectedMissao, setSelectedMissao] = useState<any>(null);
  const [selectedValidacao, setSelectedValidacao] = useState<any>(null);
  const [filtroStatus, setFiltroStatus] = useState('todas');
  const [filtroTipo, setFiltroTipo] = useState('todos');

  // Tipos de missão
  const tiposMissao = [
    'Venda de Produto',
    'Prestação de Serviço',
    'Meta Atingida',
    'Ação Executada',
    'Ativação de Clientes',
    'Atendimento e Suporte',
  ];

  // Critérios disponíveis
  const criterios = [
    'Meta mínima',
    'Ação executada',
    'Quantidade de vendas em um período',
    'Valor acumulado de vendas em um período',
    'Ticket médio de Vendas em um período',
    'Quantidade de Serviços em um período',
    'Valor acumulado de Serviços em um período',
    'Ticket médio de Serviços em um período',
    'Quantidade de ativação de novos clientes em um período',
    'Quantidade de reativação de clientes perdidos em um período',
  ];

  // Missões cadastradas
  const missoes = [
    {
      id: 1,
      nome: 'Vendedor Estrela',
      tipo: 'Venda de Produto',
      xp: 500,
      criterio: 'Quantidade de vendas em um período',
      meta: '10 vendas/mês',
      validacao: 'Automática',
      periodicidade: 'Mensal',
      campanha: 'Campanha Verão 2024',
      status: 'Ativa',
      concluidas: 234,
      uploadObrigatorio: false,
      descricao: 'Realize 10 vendas no mês e ganhe 500 XP',
    },
    {
      id: 2,
      nome: 'Mestre dos Serviços',
      tipo: 'Prestação de Serviço',
      xp: 750,
      criterio: 'Valor acumulado de Serviços em um período',
      meta: 'R$ 50.000/mês',
      validacao: 'Automática',
      periodicidade: 'Mensal',
      campanha: 'Serviços Plus',
      status: 'Ativa',
      concluidas: 156,
      uploadObrigatorio: false,
      descricao: 'Acumule R$ 50.000 em serviços prestados no mês',
    },
    {
      id: 3,
      nome: 'Ativador Premium',
      tipo: 'Ativação de Clientes',
      xp: 1000,
      criterio: 'Quantidade de ativação de novos clientes em um período',
      meta: '5 clientes/semana',
      validacao: 'Manual',
      periodicidade: 'Semanal',
      campanha: 'Ativação Premium',
      status: 'Ativa',
      concluidas: 89,
      uploadObrigatorio: true,
      descricao: 'Ative 5 novos clientes na semana com comprovação',
    },
    {
      id: 4,
      nome: 'Suporte 5 Estrelas',
      tipo: 'Atendimento e Suporte',
      xp: 300,
      criterio: 'Ação executada',
      meta: '20 atendimentos/dia',
      validacao: 'Automática',
      periodicidade: 'Diária',
      campanha: 'Todas',
      status: 'Ativa',
      concluidas: 567,
      uploadObrigatorio: false,
      descricao: 'Realize 20 atendimentos com qualidade no dia',
    },
  ];

  // Fila de validação
  const filaValidacao = [
    {
      id: 1,
      participante: 'João Silva',
      email: 'joao.silva@empresa.com',
      missao: 'Ativador Premium',
      data: '15/01/2024',
      comprovante: 'comprovante_001.pdf',
      status: 'Pendente',
      observacoes: 'Ativação de 5 novos clientes conforme meta semanal',
    },
    {
      id: 2,
      participante: 'Maria Santos',
      email: 'maria.santos@empresa.com',
      missao: 'Ativador Premium',
      data: '14/01/2024',
      comprovante: 'comprovante_002.pdf',
      status: 'Pendente',
      observacoes: 'Documentação completa de ativação de clientes',
    },
    {
      id: 3,
      participante: 'Carlos Oliveira',
      email: 'carlos.oliveira@empresa.com',
      missao: 'Vendedor Estrela',
      data: '13/01/2024',
      comprovante: 'comprovante_003.pdf',
      status: 'Pendente',
      observacoes: 'Notas fiscais das 10 vendas realizadas',
    },
  ];

  // Histórico de conclusões
  const historicoConclusoes = [
    {
      id: 1,
      participante: 'Ana Paula Costa',
      email: 'ana.costa@empresa.com',
      dataConclusao: '10/01/2024 14:30',
      xpConcedido: 1000,
      validadoPor: 'Sistema Automático',
      status: 'Aprovado',
    },
    {
      id: 2,
      participante: 'Roberto Almeida',
      email: 'roberto.almeida@empresa.com',
      dataConclusao: '09/01/2024 16:45',
      xpConcedido: 1000,
      validadoPor: 'Admin - João Gestor',
      status: 'Aprovado',
    },
    {
      id: 3,
      participante: 'Fernanda Lima',
      email: 'fernanda.lima@empresa.com',
      dataConclusao: '08/01/2024 10:20',
      xpConcedido: 0,
      validadoPor: 'Admin - João Gestor',
      status: 'Reprovado',
      motivo: 'Comprovante incompleto',
    },
    {
      id: 4,
      participante: 'Pedro Santos',
      email: 'pedro.santos@empresa.com',
      dataConclusao: '07/01/2024 11:15',
      xpConcedido: 1000,
      validadoPor: 'Sistema Automático',
      status: 'Aprovado',
    },
    {
      id: 5,
      participante: 'Juliana Rocha',
      email: 'juliana.rocha@empresa.com',
      dataConclusao: '06/01/2024 09:30',
      xpConcedido: 1000,
      validadoPor: 'Admin - Maria Supervisora',
      status: 'Aprovado',
    },
  ];

  const handleEdit = (missao: any) => {
    setSelectedMissao(missao);
    setShowEditModal(true);
  };

  const handleHistorico = (missao: any) => {
    setSelectedMissao(missao);
    setShowHistoricoModal(true);
  };

  const handleDelete = (missao: any) => {
    setSelectedMissao(missao);
    setShowDeleteModal(true);
  };

  const handleAprovar = (validacao: any) => {
    setSelectedValidacao(validacao);
    setShowAprovarModal(true);
  };

  const handleReprovar = (validacao: any) => {
    setSelectedValidacao(validacao);
    setShowReprovarModal(true);
  };

  const handleSolicitarAjuste = (validacao: any) => {
    setSelectedValidacao(validacao);
    setShowSolicitarAjusteModal(true);
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Missões & Desafios</h1>
            <p className="text-sm text-gray-600 mt-1">Gerenciamento de missões e desafios para participantes</p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => setShowValidacaoModal(true)}
              className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition-colors text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-time-line mr-2"></i>
              Fila de Validação ({filaValidacao.length})
            </button>
            <button
              onClick={() => setShowModal(true)}
              className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-add-line mr-2"></i>
              Nova Missão
            </button>
          </div>
        </div>

        {/* Filtros */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
              <select
                value={filtroStatus}
                onChange={(e) => setFiltroStatus(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              >
                <option value="todas">Todas</option>
                <option value="ativa">Ativas</option>
                <option value="inativa">Inativas</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Tipo</label>
              <select
                value={filtroTipo}
                onChange={(e) => setFiltroTipo(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              >
                <option value="todos">Todos os Tipos</option>
                {tiposMissao.map((tipo, index) => (
                  <option key={index} value={tipo}>{tipo}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Buscar</label>
              <input
                type="text"
                placeholder="Nome da missão..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>
            <div className="flex items-end">
              <button className="w-full px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium whitespace-nowrap">
                <i className="ri-filter-3-line mr-2"></i>
                Limpar Filtros
              </button>
            </div>
          </div>
        </div>

        {/* Lista de Missões */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Missão</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Tipo</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">XP</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Critério</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Meta</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Validação</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Periodicidade</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Concluídas</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Status</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Ações</th>
                </tr>
              </thead>
              <tbody>
                {missoes.map((missao) => (
                  <tr key={missao.id} className="border-t border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4">
                      <div>
                        <p className="text-sm font-medium text-gray-900">{missao.nome}</p>
                        <p className="text-xs text-gray-600">{missao.campanha}</p>
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <span className="text-sm text-gray-700">{missao.tipo}</span>
                    </td>
                    <td className="py-3 px-4 text-center">
                      <span className="inline-flex items-center px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs font-medium">
                        <i className="ri-star-fill mr-1"></i>
                        {missao.xp} XP
                      </span>
                    </td>
                    <td className="py-3 px-4">
                      <span className="text-sm text-gray-700">{missao.criterio}</span>
                    </td>
                    <td className="py-3 px-4">
                      <span className="text-sm font-medium text-gray-900">{missao.meta}</span>
                    </td>
                    <td className="py-3 px-4 text-center">
                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                        missao.validacao === 'Automática' ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'
                      }`}>
                        {missao.validacao}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-center">
                      <span className="text-sm text-gray-700">{missao.periodicidade}</span>
                    </td>
                    <td className="py-3 px-4 text-center">
                      <span className="text-sm font-bold text-teal-600">{missao.concluidas}</span>
                    </td>
                    <td className="py-3 px-4 text-center">
                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                        missao.status === 'Ativa' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                      }`}>
                        {missao.status}
                      </span>
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex items-center justify-center gap-2">
                        <button 
                          onClick={() => handleEdit(missao)}
                          className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-teal-600 hover:bg-teal-50 rounded transition-colors"
                          title="Editar"
                        >
                          <i className="ri-edit-line text-base"></i>
                        </button>
                        <button 
                          onClick={() => handleHistorico(missao)}
                          className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                          title="Histórico"
                        >
                          <i className="ri-history-line text-base"></i>
                        </button>
                        <button 
                          onClick={() => handleDelete(missao)}
                          className="w-8 h-8 flex items-center justify-center text-gray-600 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                          title="Excluir"
                        >
                          <i className="ri-delete-bin-line text-base"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Modal Nova Missão */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-900">Nova Missão</h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <div className="p-6 space-y-6">
                {/* Informações Básicas */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Informações Básicas</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Missão *</label>
                      <input
                        type="text"
                        placeholder="Ex: Vendedor Estrela"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Descrição</label>
                      <textarea
                        placeholder="Descreva a missão..."
                        rows={3}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Missão *</label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="">Selecione...</option>
                        {tiposMissao.map((tipo, index) => (
                          <option key={index} value={tipo}>{tipo}</option>
                        ))}
                        <option value="novo">+ Adicionar Novo Tipo</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">XP Concedido *</label>
                      <input
                        type="number"
                        placeholder="500"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    </div>
                  </div>
                </div>

                {/* Critérios */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Critérios</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Critério *</label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="">Selecione...</option>
                        {criterios.map((criterio, index) => (
                          <option key={index} value={criterio}>{criterio}</option>
                        ))}
                        <option value="novo">+ Adicionar Novo Critério</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Meta *</label>
                      <input
                        type="text"
                        placeholder="Ex: 10 vendas, R$ 50.000, 5 clientes"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    </div>
                  </div>
                </div>

                {/* Validação */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Validação</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Validação *</label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="automatica">Automática (integração ERP/API)</option>
                        <option value="manual">Manual (conferência de evidência)</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Upload de Comprovantes</label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="nao">Não Obrigatório</option>
                        <option value="sim">Obrigatório</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Periodicidade */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Periodicidade</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Regra de Periodicidade *</label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="unica">Única</option>
                        <option value="diaria">Diária</option>
                        <option value="semanal">Semanal</option>
                        <option value="mensal">Mensal</option>
                        <option value="anual">Anual</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Associação com Campanha</label>
                      <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="">Todas as Campanhas</option>
                        <option value="1">Campanha Verão 2024</option>
                        <option value="2">Mega Vendas Q1</option>
                        <option value="3">Ativação Premium</option>
                        <option value="4">Serviços Plus</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Status */}
                <div>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" defaultChecked className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500" />
                    <span className="text-sm font-medium text-gray-700">Missão Ativa</span>
                  </label>
                </div>
              </div>

              <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap"
                >
                  Cancelar
                </button>
                <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
                  Salvar Missão
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Editar Missão */}
        {showEditModal && selectedMissao && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-900">Editar Missão</h2>
                <button
                  onClick={() => setShowEditModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <div className="p-6 space-y-6">
                {/* Informações Básicas */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Informações Básicas</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Nome da Missão *</label>
                      <input
                        type="text"
                        defaultValue={selectedMissao.nome}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Descrição</label>
                      <textarea
                        defaultValue={selectedMissao.descricao}
                        rows={3}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Missão *</label>
                      <select defaultValue={selectedMissao.tipo} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="">Selecione...</option>
                        {tiposMissao.map((tipo, index) => (
                          <option key={index} value={tipo}>{tipo}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">XP Concedido *</label>
                      <input
                        type="number"
                        defaultValue={selectedMissao.xp}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    </div>
                  </div>
                </div>

                {/* Critérios */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Critérios</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Critério *</label>
                      <select defaultValue={selectedMissao.criterio} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="">Selecione...</option>
                        {criterios.map((criterio, index) => (
                          <option key={index} value={criterio}>{criterio}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Meta *</label>
                      <input
                        type="text"
                        defaultValue={selectedMissao.meta}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                      />
                    </div>
                  </div>
                </div>

                {/* Validação */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Validação</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Validação *</label>
                      <select defaultValue={selectedMissao.validacao === 'Automática' ? 'automatica' : 'manual'} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="automatica">Automática (integração ERP/API)</option>
                        <option value="manual">Manual (conferência de evidência)</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Upload de Comprovantes</label>
                      <select defaultValue={selectedMissao.uploadObrigatorio ? 'sim' : 'nao'} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="nao">Não Obrigatório</option>
                        <option value="sim">Obrigatório</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Periodicidade */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Periodicidade</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Regra de Periodicidade *</label>
                      <select defaultValue={selectedMissao.periodicidade.toLowerCase()} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="unica">Única</option>
                        <option value="diaria">Diária</option>
                        <option value="semanal">Semanal</option>
                        <option value="mensal">Mensal</option>
                        <option value="anual">Anual</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Associação com Campanha</label>
                      <select defaultValue={selectedMissao.campanha} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500">
                        <option value="">Todas as Campanhas</option>
                        <option value="Campanha Verão 2024">Campanha Verão 2024</option>
                        <option value="Mega Vendas Q1">Mega Vendas Q1</option>
                        <option value="Ativação Premium">Ativação Premium</option>
                        <option value="Serviços Plus">Serviços Plus</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Status */}
                <div>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" defaultChecked={selectedMissao.status === 'Ativa'} className="w-4 h-4 text-teal-600 border-gray-300 rounded focus:ring-teal-500" />
                    <span className="text-sm font-medium text-gray-700">Missão Ativa</span>
                  </label>
                </div>
              </div>

              <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
                <button
                  onClick={() => setShowEditModal(false)}
                  className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap"
                >
                  Cancelar
                </button>
                <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
                  Salvar Alterações
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Histórico de Conclusões */}
        {showHistoricoModal && selectedMissao && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <div>
                  <h2 className="text-xl font-bold text-gray-900">Histórico de Conclusões</h2>
                  <p className="text-sm text-gray-600 mt-1">Missão: {selectedMissao.nome}</p>
                </div>
                <button
                  onClick={() => setShowHistoricoModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <div className="p-6">
                {/* Estatísticas */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                  <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-lg p-4 border border-teal-200">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-xs text-teal-700 font-medium">Total de Conclusões</p>
                        <p className="text-2xl font-bold text-teal-900 mt-1">{selectedMissao.concluidas}</p>
                      </div>
                      <div className="w-12 h-12 flex items-center justify-center bg-teal-200 rounded-lg">
                        <i className="ri-checkbox-circle-line text-2xl text-teal-700"></i>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-4 border border-green-200">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-xs text-green-700 font-medium">Aprovadas</p>
                        <p className="text-2xl font-bold text-green-900 mt-1">218</p>
                      </div>
                      <div className="w-12 h-12 flex items-center justify-center bg-green-200 rounded-lg">
                        <i className="ri-check-line text-2xl text-green-700"></i>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-lg p-4 border border-red-200">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-xs text-red-700 font-medium">Reprovadas</p>
                        <p className="text-2xl font-bold text-red-900 mt-1">16</p>
                      </div>
                      <div className="w-12 h-12 flex items-center justify-center bg-red-200 rounded-lg">
                        <i className="ri-close-line text-2xl text-red-700"></i>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-lg p-4 border border-yellow-200">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-xs text-yellow-700 font-medium">XP Total Concedido</p>
                        <p className="text-2xl font-bold text-yellow-900 mt-1">{(selectedMissao.concluidas * selectedMissao.xp).toLocaleString()}</p>
                      </div>
                      <div className="w-12 h-12 flex items-center justify-center bg-yellow-200 rounded-lg">
                        <i className="ri-star-fill text-2xl text-yellow-700"></i>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tabela de Histórico */}
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Participante</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Data/Hora</th>
                          <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">XP Concedido</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Validado Por</th>
                          <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Status</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Observações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {historicoConclusoes.map((item) => (
                          <tr key={item.id} className="border-t border-gray-100 hover:bg-gray-50">
                            <td className="py-3 px-4">
                              <div>
                                <p className="text-sm font-medium text-gray-900">{item.participante}</p>
                                <p className="text-xs text-gray-600">{item.email}</p>
                              </div>
                            </td>
                            <td className="py-3 px-4">
                              <span className="text-sm text-gray-700">{item.dataConclusao}</span>
                            </td>
                            <td className="py-3 px-4 text-center">
                              <span className="inline-flex items-center px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs font-medium">
                                <i className="ri-star-fill mr-1"></i>
                                {item.xpConcedido} XP
                              </span>
                            </td>
                            <td className="py-3 px-4">
                              <span className="text-sm text-gray-700">{item.validadoPor}</span>
                            </td>
                            <td className="py-3 px-4 text-center">
                              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                                item.status === 'Aprovado' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                              }`}>
                                {item.status}
                              </span>
                            </td>
                            <td className="py-3 px-4">
                              <span className="text-sm text-gray-700">{item.motivo || '-'}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end">
                <button
                  onClick={() => setShowHistoricoModal(false)}
                  className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Confirmar Exclusão */}
        {showDeleteModal && selectedMissao && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-4">
                  <i className="ri-alert-line text-2xl text-red-600"></i>
                </div>
                <h2 className="text-xl font-bold text-gray-900 text-center mb-2">Confirmar Exclusão</h2>
                <p className="text-sm text-gray-600 text-center mb-6">
                  Tem certeza que deseja excluir a missão <strong>{selectedMissao.nome}</strong>? Esta ação não pode ser desfeita.
                </p>
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-6">
                  <p className="text-xs text-yellow-800">
                    <i className="ri-information-line mr-1"></i>
                    Ao excluir esta missão, o histórico de {selectedMissao.concluidas} conclusões será mantido, mas a missão não estará mais disponível para novos participantes.
                  </p>
                </div>
              </div>
              <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
                <button
                  onClick={() => setShowDeleteModal(false)}
                  className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap"
                >
                  Cancelar
                </button>
                <button className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium whitespace-nowrap">
                  Sim, Excluir
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Fila de Validação */}
        {showValidacaoModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <div>
                  <h2 className="text-xl font-bold text-gray-900">Fila de Validação de Missões</h2>
                  <p className="text-sm text-gray-600 mt-1">{filaValidacao.length} missões aguardando validação</p>
                </div>
                <button
                  onClick={() => setShowValidacaoModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <div className="p-6">
                <div className="space-y-4">
                  {filaValidacao.map((item) => (
                    <div key={item.id} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                      <div className="flex items-start justify-between mb-3">
                        <div>
                          <p className="text-sm font-semibold text-gray-900">{item.participante}</p>
                          <p className="text-xs text-gray-600 mt-1">{item.email}</p>
                          <p className="text-xs text-gray-600">Missão: <strong>{item.missao}</strong></p>
                          <p className="text-xs text-gray-600">Data: {item.data}</p>
                        </div>
                        <span className="inline-flex items-center px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs font-medium">
                          {item.status}
                        </span>
                      </div>
                      
                      {item.observacoes && (
                        <div className="bg-white rounded p-3 mb-3 border border-gray-200">
                          <p className="text-xs text-gray-600 font-medium mb-1">Observações:</p>
                          <p className="text-xs text-gray-700">{item.observacoes}</p>
                        </div>
                      )}

                      <div className="flex items-center gap-3 mb-3">
                        <i className="ri-file-text-line text-gray-400"></i>
                        <span className="text-sm text-gray-700">{item.comprovante}</span>
                        <button className="text-sm text-teal-600 hover:text-teal-700 font-medium">
                          <i className="ri-download-line mr-1"></i>
                          Baixar
                        </button>
                        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">
                          <i className="ri-eye-line mr-1"></i>
                          Visualizar
                        </button>
                      </div>
                      <div className="flex items-center gap-3">
                        <button 
                          onClick={() => handleAprovar(item)}
                          className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium whitespace-nowrap"
                        >
                          <i className="ri-check-line mr-2"></i>
                          Aprovar
                        </button>
                        <button 
                          onClick={() => handleReprovar(item)}
                          className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium whitespace-nowrap"
                        >
                          <i className="ri-close-line mr-2"></i>
                          Reprovar
                        </button>
                        <button 
                          onClick={() => handleSolicitarAjuste(item)}
                          className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors text-sm font-medium whitespace-nowrap"
                        >
                          <i className="ri-message-3-line mr-2"></i>
                          Solicitar Ajuste
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal Aprovar */}
        {showAprovarModal && selectedValidacao && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-2xl text-green-600"></i>
                </div>
                <h2 className="text-xl font-bold text-gray-900 text-center mb-2">Aprovar Missão</h2>
                <p className="text-sm text-gray-600 text-center mb-6">
                  Confirma a aprovação da missão <strong>{selectedValidacao.missao}</strong> para <strong>{selectedValidacao.participante}</strong>?
                </p>
                
                <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-green-800 font-medium">XP a ser concedido:</span>
                    <span className="text-lg font-bold text-green-900">1000 XP</span>
                  </div>
                  <p className="text-xs text-green-700">
                    O participante receberá os pontos imediatamente após a aprovação.
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Observações (opcional)</label>
                  <textarea
                    placeholder="Adicione observações sobre a aprovação..."
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>
              <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
                <button
                  onClick={() => setShowAprovarModal(false)}
                  className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap"
                >
                  Cancelar
                </button>
                <button className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium whitespace-nowrap">
                  Confirmar Aprovação
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Reprovar */}
        {showReprovarModal && selectedValidacao && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-4">
                  <i className="ri-close-line text-2xl text-red-600"></i>
                </div>
                <h2 className="text-xl font-bold text-gray-900 text-center mb-2">Reprovar Missão</h2>
                <p className="text-sm text-gray-600 text-center mb-6">
                  Confirma a reprovação da missão <strong>{selectedValidacao.missao}</strong> para <strong>{selectedValidacao.participante}</strong>?
                </p>
                
                <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
                  <p className="text-xs text-red-800">
                    <i className="ri-information-line mr-1"></i>
                    O participante será notificado sobre a reprovação e não receberá XP por esta tentativa.
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Motivo da Reprovação *</label>
                  <textarea
                    placeholder="Descreva o motivo da reprovação..."
                    rows={4}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
                  />
                </div>
              </div>
              <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
                <button
                  onClick={() => setShowReprovarModal(false)}
                  className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap"
                >
                  Cancelar
                </button>
                <button className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium whitespace-nowrap">
                  Confirmar Reprovação
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Solicitar Ajuste */}
        {showSolicitarAjusteModal && selectedValidacao && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-full mx-auto mb-4">
                  <i className="ri-message-3-line text-2xl text-orange-600"></i>
                </div>
                <h2 className="text-xl font-bold text-gray-900 text-center mb-2">Solicitar Ajuste</h2>
                <p className="text-sm text-gray-600 text-center mb-6">
                  Solicite ajustes no comprovante enviado por <strong>{selectedValidacao.participante}</strong> para a missão <strong>{selectedValidacao.missao}</strong>.
                </p>
                
                <div className="bg-orange-50 border border-orange-200 rounded-lg p-3 mb-4">
                  <p className="text-xs text-orange-800">
                    <i className="ri-information-line mr-1"></i>
                    O participante receberá uma notificação com suas orientações e poderá reenviar o comprovante.
                  </p>
                </div>

                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">O que precisa ser ajustado? *</label>
                    <textarea
                      placeholder="Descreva detalhadamente o que precisa ser corrigido ou complementado..."
                      rows={4}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Prazo para Reenvio</label>
                    <select className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500">
                      <option value="24">24 horas</option>
                      <option value="48">48 horas</option>
                      <option value="72">72 horas</option>
                      <option value="168">7 dias</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
                <button
                  onClick={() => setShowSolicitarAjusteModal(false)}
                  className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap"
                >
                  Cancelar
                </button>
                <button className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors text-sm font-medium whitespace-nowrap">
                  Enviar Solicitação
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
